module.exports = __webpack_public_path__ + "img/lookup2.4d60a329.png";